import { useCallback, useEffect, useMemo, useState, type ReactNode } from 'react'
import {
  CICD_ACCESS_STALE_EVENT,
  getCicdAccess,
  type CicdAccess,
} from '../services/cicd-access-service'
import { CicdAccessContext } from './cicd-access-state'

export function CicdAccessProvider({ children }: { children: ReactNode }) {
  const [access, setAccess] = useState<CicdAccess | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  const refresh = useCallback(async () => {
    setLoading(true)
    setError(false)
    try {
      setAccess(await getCicdAccess())
    } catch {
      setAccess(null)
      setError(true)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refresh()
  }, [refresh])

  useEffect(() => {
    const refreshStaleAccess = () => void refresh()
    window.addEventListener(CICD_ACCESS_STALE_EVENT, refreshStaleAccess)
    return () =>
      window.removeEventListener(CICD_ACCESS_STALE_EVENT, refreshStaleAccess)
  }, [refresh])

  const value = useMemo(
    () => ({ access, loading, error, refresh }),
    [access, error, loading, refresh],
  )

  return (
    <CicdAccessContext.Provider value={value}>
      {children}
    </CicdAccessContext.Provider>
  )
}
